"use strict";

{
  /**
   * LPテーマ（utm_target）。
   * 03 → data-utm-target="03"（青・ヘッダー／フッター帯ほか）。
   * 02 → data-utm-target="02"（オレンジ・ヘッダー帯のみ。他は黄LP系と同じセレクタで維持）。
   * 未付与・01・その他 → 属性なし（黄テーマ既定）。
   * FV サブコピー（.p-fv__catchTitleSub）はキーに応じて切替。
   * ヘッダーロゴ：03 のみ logo_03.webp、未付与・01・02・その他は logo_0102.webp。
   */
  const UTM_TARGET_DATA_ATTR = "data-utm-target";
  const UTM_TARGET_VALUE_ORANGE = "02";
  const UTM_TARGET_VALUE_BLUE = "03";
  const UTM_TARGET_FV_SUBLINE_DEFAULT = "プロパンガスエリアの新規手続き";
  const UTM_TARGET_FV_SUBLINE = {
    "01": "レモンガスエリアの新規手続き",
    "02": "ミツウロコガスエリアの新規手続き",
    "03": "東海ガスエリアの新規手続き",
  };
  const HEADER_LOGO_SRC_03 = "assets/img/logo_03.webp";
  const HEADER_LOGO_SRC_0102 = "assets/img/logo_0102.webp";
  const MODAL_REDIRECT_BOW_SRC_03 = "assets/img/contact_img-bow_03.webp";
  const MODAL_REDIRECT_BOW_SRC_01 = "assets/img/contact_img-bow_01.webp";
  const THANKS_BOW_SRC_02 = "assets/img/contact_img-bow_02.webp";

  function applyUtmTargetTheme() {
    const raw = new URLSearchParams(window.location.search).get("utm_target");
    const root = document.documentElement;
    if (raw === UTM_TARGET_VALUE_BLUE) {
      root.setAttribute(UTM_TARGET_DATA_ATTR, UTM_TARGET_VALUE_BLUE);
    } else if (raw === UTM_TARGET_VALUE_ORANGE) {
      root.setAttribute(UTM_TARGET_DATA_ATTR, UTM_TARGET_VALUE_ORANGE);
    } else {
      root.removeAttribute(UTM_TARGET_DATA_ATTR);
    }

    const logoImg = document.querySelector(".p-header__logo img");
    if (logoImg) {
      logoImg.src = raw === UTM_TARGET_VALUE_BLUE ? HEADER_LOGO_SRC_03 : HEADER_LOGO_SRC_0102;
    }

    const subEl = document.querySelector(".p-fv__catchTitleSub");
    if (subEl) {
      const line =
        raw !== null && Object.prototype.hasOwnProperty.call(UTM_TARGET_FV_SUBLINE, raw)
          ? UTM_TARGET_FV_SUBLINE[raw]
          : UTM_TARGET_FV_SUBLINE_DEFAULT;
      subEl.textContent = line;
    }

    const redirectBowImg = document.querySelector(
      '[data-modal-panel="redirect"] .p-modal__redirectImg'
    );
    if (redirectBowImg) {
      if (raw === UTM_TARGET_VALUE_BLUE) {
        redirectBowImg.src = MODAL_REDIRECT_BOW_SRC_03;
        redirectBowImg.width = 654;
        redirectBowImg.height = 434;
      } else if (raw === UTM_TARGET_VALUE_ORANGE) {
        redirectBowImg.src = THANKS_BOW_SRC_02;
        redirectBowImg.width = 978;
        redirectBowImg.height = 600;
      } else {
        redirectBowImg.src = MODAL_REDIRECT_BOW_SRC_01;
        redirectBowImg.width = 978;
        redirectBowImg.height = 600;
      }
    }

    const thanksBowImg = document.querySelector(".p-contactThanks__img");
    if (thanksBowImg) {
      if (raw === UTM_TARGET_VALUE_BLUE) {
        thanksBowImg.src = MODAL_REDIRECT_BOW_SRC_03;
        thanksBowImg.width = 654;
        thanksBowImg.height = 434;
      } else if (raw === UTM_TARGET_VALUE_ORANGE) {
        thanksBowImg.src = THANKS_BOW_SRC_02;
        thanksBowImg.width = 978;
        thanksBowImg.height = 600;
      } else {
        thanksBowImg.src = MODAL_REDIRECT_BOW_SRC_01;
        thanksBowImg.width = 978;
        thanksBowImg.height = 600;
      }
    }
  }

  /** TOP（index）へのパス。現在のクエリを付与（黄／オレンジ／青いずれも同一ルール）。 */
  function hrefToTopWithCurrentSearch() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("from") === "gas-compare") {
      return "./gas-compare/";
    }
    const topPath = "./index.html";
    const q = window.location.search;
    return q ? `${topPath}${q}` : topPath;
  }

  /** 送信完了：閉じるリンクの遷移先 */
  function applyContactThanksCloseHref() {
    const closeEl = document.querySelector(".p-contactThanks__close");
    if (!closeEl || closeEl.tagName !== "A") {
      return;
    }
    closeEl.setAttribute("href", hrefToTopWithCurrentSearch());
    if (new URLSearchParams(window.location.search).get("from") === "gas-compare") {
      closeEl.setAttribute("aria-label", "閉じる（申込みページへ）");
    }
  }

  /** ヘッダーロゴ：同一ルールで TOP へ（サンクス等サブページでも utm を維持） */
  function applyHeaderLogoTopHref() {
    const logoEl = document.querySelector(".p-header__logo");
    if (!logoEl || logoEl.tagName !== "A") {
      return;
    }
    logoEl.setAttribute("href", hrefToTopWithCurrentSearch());
  }

  applyUtmTargetTheme();
  applyContactThanksCloseHref();
  applyHeaderLogoTopHref();

  const COOKIE_DIRECTION_ONLY = "direction_only";
  const COOKIE_EXPIRE_DAYS = 365;

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const row = document.cookie.split("; ").find((r) => r.startsWith(`${name}=`));
    if (!row) {
      return null;
    }
    return decodeURIComponent(row.slice(name.length + 1));
  }

  function openModalById(id) {
    const dialog = document.getElementById(id);
    if (!dialog) {
      return false;
    }
    if (!dialog.open) {
      globalThis.showModalKeepScroll(dialog);
    }
    return true;
  }

  const modal1OpenBtns = document.querySelectorAll('[data-dialog="modal1"]');
  modal1OpenBtns.forEach((modal1OpenBtn) => {
    modal1OpenBtn.addEventListener("click", () => {
      setCookie(COOKIE_DIRECTION_ONLY, "1", COOKIE_EXPIRE_DAYS);
    });
  });

  const telLinks = document.querySelectorAll('a[href^="tel:"]');
  telLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      if (link.closest("dialog")) {
        return;
      }
      if (getCookie(COOKIE_DIRECTION_ONLY) !== "1") {
        return;
      }
      const dialog = document.getElementById("modal1");
      if (!dialog) {
        return;
      }
      e.preventDefault();
      openModalById("modal1");
    });
  });
}
